import React, { useState } from "react";
import { FaLinkedin } from "react-icons/fa";
import { IoPhonePortraitOutline } from "react-icons/io5";
import { MdMailOutline } from "react-icons/md";

const Footer = () => {
  const [email, setEmail] = useState("");
  const [subscribed, setSubscribed] = useState(false);
  const [error, setError] = useState("");

  const handleSubscribe = async (e) => {
    e.preventDefault();
    setSubscribed(false);
    setError("");

    try {
      const response = await fetch("hhttps://api.circuitcytechnology.com/subscribe-newsletter", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });

      const data = await response.json();
      if (response.ok) {
        setSubscribed(true);
        setEmail("");
      } else {
        setError(data.error || "Subscription failed");
      }
    } catch (err) {
      setError("Server error. Please try again later.");
    }
  };

  return (
    <footer className="bg-sky-700 text-white pt-14 font-sans">
      <div className="max-w-7xl mx-auto px-6 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10 pb-14">
        {/* Contact Info */}
        <div>
          <h3 className="text-2xl font-bold mb-5 border-b border-white pb-2 inline-block">
            Contact Us
          </h3>
          <div className="space-y-4 text-base">
            <div className="flex items-center gap-3">
              <IoPhonePortraitOutline className="text-blue-200 text-xl" />
              <a href="tel:+919112440863" className="hover:text-yellow-300 transition">
                +91 9112440863
              </a>
            </div>
            <div className="flex items-center gap-3">
              <MdMailOutline className="text-blue-200 text-xl" />
              <a
                href="mailto:hr.circuitcynagpur@outlook.com"
                className="hover:text-yellow-300 transition"
              >
                hr.circuitcynagpur@outlook.com
              </a>
            </div>
            <div className="flex items-center gap-3">
              <FaLinkedin className="text-blue-200 text-xl" />
              <a
                href="https://www.linkedin.com/in/circuitcy-technology-nagpur-95158a174/"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-yellow-300 transition"
              >
                Circuitcy Technology
              </a>
            </div>
          </div>

          <div className="mt-20">
            <h4 className="text-xl font-semibold text-yellow-300 mb-1">
              "Your Bridge from Classroom to Industry"
            </h4>
            <p className="text-sm text-white italic">
              Learn what textbooks can’t teach.
            </p>
          </div>
        </div>

        {/* Address & Map */}
        <div className="flex flex-col gap-6">
          <div>
            <h3 className="text-2xl font-bold mb-5 border-b border-white pb-2 inline-block">
              Address
            </h3>
            <p className="text-base leading-relaxed text-gray-100">
              Circuitcy Technology Pvt. Ltd. <br />
              Near Sitabuldi Metro Station, Sitabuldi, <br />
              Nagpur, Maharashtra - 440012 <br />
              India
            </p>
          </div>
          <div className="rounded-xl overflow-hidden shadow-lg border-4 border-white">
            <a
              href="https://www.google.com/maps?q=21.144095,79.085115"
              target="_blank"
              rel="noopener noreferrer"
              className="block"
              title="Click to open in Google Maps"
            >
              <iframe
                title="Circuitcy Location"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d930.3021495049718!2d79.08511556957166!3d21.144095298783412!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bd4c1dbcc546935%3A0xfe32cd1213c5545d!2sCircuitcy%20Technology%20Nagpur!5e0!3m2!1sen!2sin&gestureHandling=cooperative"
                width="100%"
                height="200"
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                className="w-full h-56"
              ></iframe>
            </a>
          </div>
        </div>

        {/* Newsletter + Tagline */}
        <div className="flex flex-col justify-between gap-6">
          <div>
            <h3 className="text-2xl font-bold mb-5 border-b border-white pb-2 inline-block">
              Newsletter
            </h3>
            <p className="text-sm text-gray-100 mb-4">
              Get internship updates, industry news, and learning resources delivered straight to your inbox.
            </p>
            <form onSubmit={handleSubscribe} className="flex flex-col sm:flex-row items-center gap-4">
              <input
                type="email"
                placeholder="Your email address"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full px-4 py-2 rounded-lg text-black focus:outline-none"
              />
              <button
                type="submit"
                className="bg-yellow-400 hover:bg-yellow-300 text-black font-semibold px-4 py-2 rounded-lg transition"
              >
                Subscribe
              </button>
            </form>
            {subscribed && <p className="text-green-200 mt-2">Subscribed successfully!</p>}
            {error && <p className="text-red-300 mt-2">{error}</p>}
          </div>

          {/* Tagline */}
          <div className="text-left animate-fade-in flex flex-col leading-tight sm:items-start items-center mb-14">
            <h4 className="text-3xl sm:text-5xl font-black uppercase tracking-tight leading-snug">
              <span className="text-yellow-300 block">Learn. Build.</span>
              <span className="text-white block">Excel with,</span>
              <span className="text-yellow-400 block">Circuitcy!</span>
            </h4>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="bg-sky-800 border-t border-white/20 text-sm text-center py-5">
        &copy; {new Date().getFullYear()} <span className="font-semibold">Circuitcy</span>. All rights reserved.
      </div>
    </footer>
  );
};

export default Footer;
